import {
  Link,
  Text,
} from '@chakra-ui/react';
import {
  useCoInvestExpenditure,
} from '@src/modules/performance/context/reports-api-hooks';
import { useRecoilValue } from 'recoil';
import { currentDatabaseSelector } from '@transport-insights/uikit';
import StackedAreaChart from '@src/modules/performance/components/charts/StackedAreaChart';
import { CHART_COLOURS } from '@src/modules/performance/shared/constants';
import ReportSection from './ReportSection';

const informationSource = {
  title: 'Funding',
  content: [
    {
      title: 'Transport co-invested expenditure and funding share',
      description:
  <Text fontSize="inherit" mb={2}>
    All transport-related expenditure co-invested by NZTA (NZTA share) and Approved Organisations (local share).
    Expenditure includes Road Maintenance, Road Improvements, Walking, Cycling, Investment management, public transport, promotion of road safety and demand management
  </Text>,
      source:
  <Text fontSize="inherit" as="span">
    Sourced from
    {' '}
    <Link href="https://www.nzta.govt.nz/planning-and-investment/learning-and-resources/transport-data/data-and-tools/" isExternal>NZTA Data and Tools</Link>
  </Text>,
    },
  ],
};

function TransportProgrammeDeliveryFunding() {
  const { data, isLoading } = useCoInvestExpenditure();
  const currentDatabase = useRecoilValue(currentDatabaseSelector);
  const distinctYears = [...new Set(data?.map((item) => item.Year))];
  const lockYear = data?.[0]?.LockYear || null;
  const chartData = [
    {
      name: currentDatabase?.name || 'TA',
      type: 'area',
      data: data
        ?.filter((x) => x.FundingAuthority === 'TA')
        .map((item) => ({
          x: item.Year,
          y: item.Value / 1000000, // Convert to millions
        })),
      color: CHART_COLOURS.transblue,
    },
    {
      name: 'NLTF',
      type: 'area',
      data: data
        ?.filter((x) => x.FundingAuthority === 'Waka Kotahi')
        .map((item) => ({
          x: item.Year,
          y: item.Value / 1000000,
        })),
      color: CHART_COLOURS.transgrey,
    },
  ];

  return (
    <ReportSection
      title="Funding"
      informationSource={informationSource}
      isLoading={isLoading || !data}
      lockYear={lockYear}
    >
      <StackedAreaChart
        title="NLTF expenditure"
        categories={distinctYears}
        series={chartData}
        width="280"
        height="280"
        prefix="$"
        suffix="M"
      />
    </ReportSection>
  );
}

export default TransportProgrammeDeliveryFunding;
